import React from "react";
import { IoShieldCheckmarkOutline } from "react-icons/io5";
import Person from "../Person";
import { ROLE_LABELS } from "./constants";

export default function WorkspacePermissionsList({
  membres,
  loadingMembres,
  currentUserMembre,
  user,
  onOpenPerms,
}) {
  return (
    <div className="card border-0 mb-4">
      <div className="card-header bg-transparent border-bottom d-flex align-items-center gap-2">
        <IoShieldCheckmarkOutline size={20} />
        <h5 className="mb-0">Rôles et permissions</h5>
      </div>
      <div className="card-body p-0">
        {loadingMembres ? (
          <div className="text-center py-4">
            <div className="spinner-border text-primary" role="status" />
          </div>
        ) : (
          <>
            {currentUserMembre && (
              <div className="d-flex align-items-center gap-3 p-3 border-bottom bg-light">
                <Person
                  person={{
                    image: user?.userImage,
                    nom: user?.nom,
                    prenom: user?.prenom,
                    colors: user?.color,
                    userId: user?.userId,
                  }}
                />
                <div className="flex-fill">
                  <strong>{user?.prenom} {user?.nom}</strong>
                  <br />
                  <small className="text-muted">Vous</small>
                </div>
                <span className="badge bg-primary text-capitalize">
                  {ROLE_LABELS[currentUserMembre.role] || currentUserMembre.role}
                </span>
              </div>
            )}
            {membres.filter((m) => m.userId !== user?.userId).length === 0 ? (
              <p className="text-center text-muted py-4 mb-0">
                Aucun autre membre.
              </p>
            ) : (
              membres
                .filter((m) => m.userId !== user?.userId)
                .map((membre) => (
                  <div
                    key={membre._id}
                    className="d-flex align-items-center gap-3 p-3 border-bottom"
                  >
                    <Person
                      person={{
                        image: membre.userImage,
                        nom: membre.nom,
                        prenom: membre.prenom,
                        colors: membre.color,
                        userId: membre.userId,
                      }}
                    />
                    <div className="flex-fill">
                      <strong>
                        {membre.prenom} {membre.nom}
                      </strong>
                      <br />
                      <small className="text-muted">
                        {ROLE_LABELS[membre.role] || membre.role}
                      </small>
                    </div>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      title="Permissions"
                      onClick={() => onOpenPerms(membre)}
                    >
                      <IoShieldCheckmarkOutline />
                    </button>
                  </div>
                ))
            )}
          </>
        )}
      </div>
    </div>
  );
}
